import { track } from "~/modules/analytics/track";
import { UserSettingsEvents } from "../analytics/events/userSettings";
import {
    UserProfileAcquisitionChannels,
    UserProfileAssetClassInterests,
    UserProfileOccupations,
} from "./store/types";

// // // //

/**
 * trackNewUserProfileSubmit
 * Tracks the event when a new user successfully updates their profile
 */
export function trackNewUserProfileSubmitSuccess() {
    track(UserSettingsEvents.NewProfileSubmitSuccess);
}

/**
 * trackNewUserProfileSubmitError
 * Tracks the event when a new user encounteres an error updating their profile
 */
export function trackNewUserProfileSubmitError() {
    track(UserSettingsEvents.NewProfileSubmitError);
}

/**
 * trackUpdateOccupationSuccess
 * Tracks the event when a user successfully updates UserProfile.occupation
 * @param props
 */
export function trackUpdateOccupationSuccess(props: {
    oldValue: UserProfileOccupations;
    newValue: UserProfileOccupations;
}) {
    track(UserSettingsEvents.UpdateOccupationSuccess, props);
}

/**
 * trackUpdateOccupationError
 * Tracks the event when a user updates their OccupationError
 * @param props
 */
export function trackUpdateOccupationError(props: {
    oldValue: UserProfileOccupations;
    newValue: UserProfileOccupations;
}) {
    track(UserSettingsEvents.UpdateOccupationError, props);
}

/**
 * trackUpdateAcquisitionChannelSuccess
 * Tracks the event when a user successfully updates UserProfile.acquisitionChannel
 * @param props
 */
export function trackUpdateAcquisitionChannelSuccess(props: {
    oldValue: UserProfileAcquisitionChannels;
    newValue: UserProfileAcquisitionChannels;
}) {
    track(UserSettingsEvents.UpdateAcquisitionChannelSuccess, props);
}

/**
 * trackUpdateAcquisitionChannelError
 * Tracks the event when a user updates their AcquisitionChannelError
 * @param props
 */
export function trackUpdateAcquisitionChannelError(props: {
    oldValue: UserProfileAcquisitionChannels;
    newValue: UserProfileAcquisitionChannels;
}) {
    track(UserSettingsEvents.UpdateAcquisitionChannelError, props);
}

/**
 * trackUpdateAssetClassInterestSuccess
 * Tracks the event when a user successfully updates UserProfile.AssetClassInterest
 * @param props
 */
export function trackUpdateAssetClassInterestSuccess(props: {
    oldValue: UserProfileAssetClassInterests[];
    newValue: UserProfileAssetClassInterests[];
}) {
    track(UserSettingsEvents.UpdateAssetClassInterestSuccess, props);
}

/**
 * trackUpdateAssetClassInterestError
 * Tracks the event when a user encounters an error updating UserProfile.AssetClassInterest
 * @param props
 */
export function trackUpdateAssetClassInterestError(props: {
    oldValue: UserProfileAssetClassInterests[];
    newValue: UserProfileAssetClassInterests[];
}) {
    track(UserSettingsEvents.UpdateAssetClassInterestError, props);
}

/**
 * trackUpdateShouldReceiveMarketingSuccess
 * Tracks the event when a user successfully updates UserProfile.ShouldReceiveMarketing
 * @param props
 */
export function trackUpdateShouldReceiveMarketingSuccess(props: {
    oldValue: boolean;
    newValue: boolean;
}) {
    track(UserSettingsEvents.UpdateShouldReceiveMarketingSuccess, props);
}

/**
 * trackUpdateShouldReceiveMarketingError
 * Tracks the event when a user encounters an error updating UserProfile.ShouldReceiveMarketing
 * @param props
 */
export function trackUpdateShouldReceiveMarketingError(props: {
    oldValue: boolean;
    newValue: boolean;
}) {
    track(UserSettingsEvents.UpdateShouldReceiveMarketingError, props);
}
